import { AttendanceService } from '@services/attendance.service'

export default {
  async updateAttendanceOfSetionStudent({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const [response, error] = await AttendanceService.updateAttendanceOfSetionStudent(
      payload,
      commit,
    )
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },

  async updatePeriodAttendanceOfStudent({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const [response, error] = await AttendanceService.updatePeriodAttendanceOfStudent(
      payload,
      commit,
    )
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },

  async getAttendanceOfSetionStudentBYId({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const [response, error] = await AttendanceService.getAttendanceOfSetionStudentBYId(
      payload,
      commit,
    )
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },
  async markDailyAttendance({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })

    const [response, error] = await AttendanceService.markDailyAttendance(payload)

    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    } else {
      commit(
        'toast/NEW',
        { message: 'Attendance marked successfully!', type: 'success' },
        { root: true },
      )
    }

    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },
  async updateDailyAttendance({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const response = await AttendanceService.updateDailyAttendance(payload, commit)
    if (!response)
      commit('toast/NEW', { message: 'Something went wrong', type: 'error' }, { root: true })
    commit('layout/IS_LOADING', false, { root: true })
    return response
  },
  async getDailyAttendanceList({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    try {
      const response = await AttendanceService.getDailyAttendanceList(payload)
      const data = response?.data
      return { records: data.records, meta: data.meta }
    } catch (error) {
      commit(
        'toast/NEW',
        { message: error?.message || 'Something went wrong', type: 'error' },
        { root: true },
      )
    } finally {
      commit('layout/IS_LOADING', false, { root: true })
    }
  },
  async markPeriodAttendance({ commit }, payload) {
    commit('layout/IS_LOADING', true, { root: true })
    const [response, error] = await AttendanceService.markPeriodAttendance(payload, commit)
    if (error) {
      commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
    }
    commit('layout/IS_LOADING', false, { root: true })
    return [response, error]
  },
  getPeriodAttendanceDetails({ state, commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      AttendanceService.getPeriodAttendanceDetails(payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          commit('toast/NEW', { message: error.message, type: 'error' }, { root: true })
        })
    })
  },
}
